
import * as vercelRuntime$H_KG_MG14F6I_DZpS38SS_V6ZahlJFQPqOJRlx9qmrk from '/vercel/path0/node_modules/.pnpm/@nuxt+image@1.10.0_@upstash+redis@1.35.0_@vercel+kv@3.0.0_db0@0.3.2_drizzle-orm@0.39.3__ef30dfed29ac78f2ebf3382fc1c04610/node_modules/@nuxt/image/dist/runtime/providers/vercel'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [
    "bitbeli.cz",
    "cms.develit.io"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp",
    "webp",
    "webp",
    "webp",
    "webp",
    "webp",
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['vercel']: { provider: vercelRuntime$H_KG_MG14F6I_DZpS38SS_V6ZahlJFQPqOJRlx9qmrk, defaults: {} }
}
        